import { render, staticRenderFns } from "./customTree.vue?vue&type=template&id=15c928ba&scoped=true&"
import script from "./customTree.vue?vue&type=script&lang=js&"
export * from "./customTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c928ba",
  null
  
)

export default component.exports